var __jsx = React.createElement;
import React from "react";
import MuscleTooltip from "../tooltip";
import { cn } from "@lib/cn";
import Icons from "../../../icons";
import APP_CONFIGURATION from "@lib/app.config";
const ChipDisclaimer = _ref => {
  let {
    text,
    message,
    tooltipPlacement = 'bottom',
    showIcon = true,
    toolTipMaxWidth = 238,
    toolTipPadding,
    chipClassName,
    onClick,
    customBackgroundColor,
    customContainerClassName,
    customTextClassName,
    customIconClassName
  } = _ref;
  const chipContent = __jsx("div", {
    className: cn(chipClassName),
    style: {
      background: customBackgroundColor
    }
  }, __jsx("p", {
    className: cn(customTextClassName)
  }, text), showIcon && __jsx(Icons.info, {
    className: customIconClassName
  }));
  return __jsx("div", {
    className: cn(customContainerClassName),
    onClick: onClick
  }, message ? __jsx(MuscleTooltip, {
    text: message,
    placement: tooltipPlacement,
    maxWidth: toolTipMaxWidth,
    padding: toolTipPadding,
    backgroundColor: APP_CONFIGURATION.colors.tooltip.background
  }, chipContent) : chipContent);
};
export default ChipDisclaimer;